import  { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFilter } from '../context/FilterContext';

const ProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useFilter();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  // If not logged in, don't render anything until redirect is done
  if (!isLoggedIn) return null;

  return children;
};

export default ProtectedRoutes;
